[
    "corepatterns/dashboards/powerbi",
    "sales/dashboards/organizationoverview",
    "sales/dashboards/standardorganizationoverview",
    "sales/dashboards/salespersondashboard",
    "sales/dashboards/administrativedashboard",
    "sales/dashboards/accountantdashboard",
    "sales/dashboards/invoiceorganizationoverview",
    "sales/dashboards/plusorganizationoverview"
]
